import { ErrorView } from '../ErrorView'

export function ErrorFallbackComponent() {
  return <ErrorView titleText={null} secondaryText={null} />
}

export default ErrorFallbackComponent
